<div [alarisLoading]="form.providersService.loading$">
	<form [formGroup]="form.sourceForm">
		<div>
			<div class="form-group">
				<alaris-tabs-button
						[bg]="'lighten'"
						[formControl]="form.sourceForm.controls.connectionType"
						[tabs]="form.connectionTypeTabs"
				></alaris-tabs-button>

				<ds-input
						[label]="'sources.name' | translate"
						[formControl]="form.sourceForm.controls.name"
						[errors]="errors"
						[readonly]="!!form.sourceForm.controls.sourceId.value"
						[state]="!!form.sourceForm.controls.sourceId.value ? 'disabled' : 'enabled'"
				></ds-input>

				<ds-select-dropdown-preset
						[options]="form.providers()"
						[formControl]="form.sourceForm.controls.type"
						[optionLabelField]="'name'"
						[search]="true"
				>
					<ds-select
							[label]="'sources.type' | translate"
							[labelAsterisk]="true"
							[labelField]="'name'"
							[errors]="errors"
							slot="trigger"
					></ds-select>
				</ds-select-dropdown-preset>

				@for (item of form.preparedFields(); track $index) {
					@if (item.type === 'header') {
						<h3>{{ "sources.groups." + item.groupName | translate }}</h3>
					} @else {
						@if (item.tableField.type === "checkbox") {
							<ds-checkbox
									[formControl]="item.control"
									[indeterminate]="false"
									[checked]="item.control.value"
									(checkedChange)="item.control.setValue($event)"
									[id]="item.field.fieldName"
							>
								{{ item.tableField.name | translate }}
							</ds-checkbox>
						} @else {
							@if (item.fieldName === 'retries' || item.fieldName === 'ttl' || item.fieldName === 'requestTimeout') {
								<ds-input
										class="w-35"
										[formControl]="item.control"
										type="number"
										[label]="item.tableField.name | translate"
										[errors]="errors"
										[hint]="item.example"
								></ds-input>
							} @else if (item.fieldName === 'ip') {
								<ds-input
										class="w-75"
										[formControl]="item.control"
										[label]="item.tableField.name | translate"
										[errors]="errors"
										[hint]="item.example"
								></ds-input>
							} @else if (item.fieldName === 'port') {
								<ds-input
										class="w-25"
										type="number"
										[formControl]="item.control"
										[label]="item.tableField.name | translate"
										[errors]="errors"
										[hint]="item.example"
								></ds-input>
							} @else if (item.fieldName === 'currencyName') {
								<ds-select-dropdown-preset
										[options]="form.currencies()"
										[formControl]="item.control"
										[optionLabelField]="'name'"
										[search]="true"
										[disabled]="form.sourceForm.controls.sourceId.value !== null">
									<ds-select
											[label]="'currencies.name' | translate"
											[labelAsterisk]="true"
											[labelField]="'name'"
											[errors]="errors"
											[labelHint]="true"
											[labelPopoverText]="'sources.currency_tooltip' | translate"
											slot="trigger"
									>
										<ds-badge-icon slot="left" mode="color" [iconName]="getIconName(item.control.value)"></ds-badge-icon>
									</ds-select>
								</ds-select-dropdown-preset>
							} @else if (item.fieldName === 'huntStop') {
								<ds-select-dropdown-preset
										[options]="form.getHuntstopOptions()"
										[formControl]="item.control"
										[optionLabelField]="'label'"
										[translateOptionsLabels]="true"
										[search]="true"
								>
									<ds-select
											[label]="item.tableField.name | translate"
											[labelAsterisk]="true"
											[errors]="errors"
											[labelField]="'label'"
											[translateValue]="true"
											[hint]="item.example"
											slot="trigger"
									></ds-select>
								</ds-select-dropdown-preset>
							} @else if (item.fieldName === 'mnpFieldType') {
								<ds-select-dropdown-preset
										[options]="form.mnpFieldTypes"
										[formControl]="item.control"
										[search]="true"
								>
									<ds-select
											[label]="item.tableField.name | translate"
											[labelAsterisk]="true"
											[errors]="errors"
											[hint]="item.example"
											slot="trigger"
									></ds-select>
								</ds-select-dropdown-preset>
							} @else if (item.fieldName === 'forceRerouteKeepingMccmncMode') {
								<ds-select-dropdown-preset
										[options]="form.getForceRerouteOptions()"
										[formControl]="item.control"
										[optionLabelField]="'label'"
										[translateOptionsLabels]="true"
										[search]="true"
								>
									<ds-select
											[label]="item.tableField.name | translate"
											[labelAsterisk]="item.tableField.required"
											[labelField]="'label'"
											[errors]="errors"
											[translateValue]="true"
											slot="trigger"
									></ds-select>
								</ds-select-dropdown-preset>
							} @else if (item.fieldName === 'responseCodeCacheList') {
								@if (form.sourceForm.controls.cacheSuccessfulResponseOnly.value === 2) {
									<ds-input
											[formControl]="item.control"
											[label]="item.tableField.name | translate"
											[errors]="errors"
											[hint]="item.example"
									></ds-input>
								}
							} @else if (item.fieldName === 'cacheSuccessfulResponseOnly') {
								<alaris-tabs-button
										[bg]="'lighten'"
										[formControl]="item.control"
										[tabs]="form.tabs"
								></alaris-tabs-button>
							} @else {
								<ds-input
										[formControl]="item.control"
										[label]="item.tableField.name | translate"
										[errors]="errors"
										[hint]="item.example"
								></ds-input>
							}
						}
					}
				}
			</div>

			<div class="footer">
				<button
						dsButton
						class="w-35"
						[mode]="'main'"
						[disabled]="form.sourceForm.invalid || !form.sourceForm.dirty"
						[view]="'normal'"
						(click)="save()"
						size="S"
				>
					{{ (form.sourceForm.controls.sourceId.value ? 'actions.save' : 'actions.create') | translate }}
				</button>

				<button
						dsButton
						class="w-35"
						[mode]="'main'"
						[view]="'normal'"
						type="button"
						(click)="close()"
						size="S"
				>
					{{ 'actions.cancel' | translate }}
				</button>
			</div>
		</div>
	</form>
</div>